// EN
export const listingRatesManager = {
  header: {
    eyebrow: "Derived rates",
    title: "Listing rates",
    subtitle:
      "Centralize your rate setup and apply it to the units you need, even across several listings, without repeating the work one by one.",
    newRate: "New rate",
  },
  baseInfo: {
    title: "Base prices per night",
    perNight: "/ night",
    hint: "Derived rates are calculated as an adjustment (% or fixed amount) on top of these base prices.",
  },
  states: {
    loading: "Loading listing rates...",
    emptyTitle: "No derived rates yet",
    emptyText:
      "Create a derived rate to sync prices with channels like Booking.com or Airbnb.",
    createFirst: "Create first rate",
  },
  group: {
    unitsCount: "{count} unit | {count} units",
    manageTitle: "Manage rate group",
    manage: "Manage",
    modalTitle: "Manage rate",
    apply: "Apply",
    appliedUnits: "Units where it's applied",
    removeSyncedWarn:
      "This rate is connected to the channel. Removing it will also delete it from the channel.",
    removeConfirm: "Remove this rate from this unit?",
    removing: "Removing...",
    confirmRemove: "Yes, remove",
    removeTitle: "Remove from this unit",
    remove: "Remove",
  },
  chips: {
    connect: "Connect",
    paused: "Paused",
    syncedTitle: "Synced with the channel",
  },
  actions: {
    editTitle: "Edit rate",
    duplicateTitle: "Duplicate or copy",
    pause: "Pause sales",
    resume: "Resume sales",
    deleteTitle: "Delete",
  },
  modal: {
    createTitle: "New derived rate",
    editTitle: "Edit rate",
    importPlaceholder: "Copy from an existing rate…",
    namePlaceholder: "Rate name",
    percentage: "% Percentage",
    fixed: "Fixed value",
    derivationHint: "A negative value lowers the base price, a positive one raises it.",
    searchPlaceholder: "Search…",
    unitsCounter: "{selected} / {total} units",
    selectAll: "Select all",
    deselectAll: "Clear all",
    loadingUnits: "Loading…",
    currentBadge: "Current",
    unitsWithRate: "{count} unit with a rate | {count} units with a rate",
    noBaseRate: "No base rate",
    noResults: 'No results for "{query}"',
    create: "Create rate",
    creating: "Creating…",
    save: "Save",
    saving: "Saving…",
  },
  delete: {
    title: "Delete derived rate",
    subtitle: "Confirm the name to avoid deleting a rate by mistake.",
    confirmCopy: "Type the rate name to confirm:",
    deleting: "Deleting...",
  },
  types: {
    apartment: "Apartment",
    house: "House",
    villa: "Villa",
    hotel: "Hotel",
    room: "Room",
    studio: "Studio",
    camping: "Camping",
    default: "Accommodation",
  },
  misc: {
    noName: "No name",
    unitFallback: "Unit #{id}",
    basePrefix: "Base:",
  },
  common: {
    cancel: "Cancel",
    delete: "Delete",
    close: "Close",
  },
  toasts: {
    loadError: "Couldn't load the listing rates",
    loadListingsError: "Couldn't load the listings",
    selectUnit: "Select at least one unit with a base rate.",
    created: "Rate created successfully",
    createdPartial: "Some rates couldn't be created",
    createError: "Couldn't create the rate",
    updated: "Rate updated successfully",
    updateError: "Couldn't update the rate",
    updateErrorGeneric: "Error updating the rate",
    deleted: "Rate deleted",
    deleteError: "Error deleting",
    groupUpdated:
      "Rate updated in {count} unit | Rate updated in {count} units",
    groupUpdatedPartial: "{success} updated, {error} with errors",
    removedFromUnit: "Rate removed from this unit",
    removeError: "Couldn't remove the rate",
    removeErrorGeneric: "Error removing the rate",
    toggleError: "Couldn't change the rate status",
  },
};
